export const WORKSPACE_TYPES: {
  product: number
  combination: number
  research: number
} = Object.freeze({
  product: 103,
  combination: 104,
  research: 105,
})
